import { createSelector } from "reselect";

const getIcgcSomatic = (state) =>
  state.variantResult && state.variantResult.icgc_somatic;

const getIcgcSomaticProperties = (state) =>
  state.schema &&
  state.schema.properties &&
  state.schema.properties.icgc_somatic;

// if any of them are not null then display the old icgc
const getifOldIcgc = createSelector(getIcgcSomatic, (icgcSomatic) => {
  return Boolean(
    icgcSomatic &&
      icgcSomatic[0] &&
      (icgcSomatic[0].id ||
        icgcSomatic[0].occurence ||
        icgcSomatic[0].main_data)
  );
});

export { getIcgcSomatic, getIcgcSomaticProperties, getifOldIcgc };
